/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
};

/** What ATS (and which api) is the source of the vacancy */
export enum AtsSource {
  /** SmartRecruiters job */
  SmartRecruitersJob = "SMART_RECRUITERS_JOB",
  /** SmartRecruiters posting */
  SmartRecruitersPosting = "SMART_RECRUITERS_POSTING",
}

/** An application block */
export type ApplicationBlock = {
  __typename?: "ApplicationBlock";
  /** An application form */
  form: ApplicationForm;
  /** The unique identifier of the block */
  id: Scalars["ID"]["output"];
  /** The type of the block */
  type: BlockType;
};

/** The input for creating/updating an application block */
export type ApplicationBlockInput = {
  /** The application form of the block */
  form: ApplicationFormInput;
  /** The unique identifier of the block */
  id: Scalars["ID"]["input"];
  /** The type of the block */
  type: BlockType;
};

/** All supported application field types */
export enum ApplicationFieldType {
  /** A availability matrix input field */
  AvailabilityMatrix = "AVAILABILITY_MATRIX",
  /** An email input field */
  Email = "EMAIL",
  /** An file upload input field */
  File = "FILE",
  /** A group if input fields */
  Group = "GROUP",
  /** A phone number input field */
  PhoneNumber = "PHONE_NUMBER",
  /** A radio group */
  RadioGroup = "RADIO_GROUP",
  /** A text input field */
  Text = "TEXT",
  /** A text area input field */
  TextArea = "TEXT_AREA",
}

/** The form of the application block */
export type ApplicationForm = {
  __typename?: "ApplicationForm";
  /** All the input fields of the application form */
  inputFields: Array<ApplicationFormField>;
};

/** The input for a question on the application form */
export type ApplicationFormAnswerInput = {
  /** The answer to the question */
  answer: DynamicInput;
  /** The unique identifier of the question */
  id: Scalars["ID"]["input"];
};

/** All supported form fields */
export type ApplicationFormField =
  | AvailabilityMatrixFormField
  | FileFormField
  | GroupFormField
  | RadioGroupFormField
  | TextAreaFormField
  | TextFormField;

/** The form of the application block */
export type ApplicationFormInput = {
  /** The screening questions of the form */
  screeningQuestions?: InputMaybe<Array<ApplicationFormScreeningQuestionInput>>;
};

/** The input for creating/updating a screening question of a application form */
export type ApplicationFormScreeningQuestionInput = {
  /** The unique identifier of a screening question */
  id: Scalars["ID"]["input"];
  /** Should this question be a knockout question and lead to automatic rejection of the applicant */
  isKnockout?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The step indicator of the screening question */
  stepIndicator?: InputMaybe<ApplicationFormStepIndicatorInput>;
};

/** The application form step to which a screening question belongs */
export enum ApplicationFormStep {
  /** The checklist group */
  Checklist = "CHECKLIST",
  /** The questions group */
  Questions = "QUESTIONS",
}

/** The step indicator of the application form. The step indicator is used to indicate a step (group of fields) in the application form. */
export type ApplicationFormStepIndicator = {
  __typename?: "ApplicationFormStepIndicator";
  /** The step indicator index */
  index: Scalars["Int"]["output"];
};

/** The step indicator (group) that the input field should be shown in */
export type ApplicationFormStepIndicatorInput = {
  /** The index (position) of the step */
  index: Scalars["Int"]["input"];
};

/** The failure result of applying for a vacancy */
export type ApplyForVacancyFailure = {
  __typename?: "ApplyForVacancyFailure";
  /** The reasons when the application is rejected */
  rejectionReasons?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Whether the application was successful */
  success: Scalars["Boolean"]["output"];
};

/** The input for applying for a vacancy */
export type ApplyForVacancyInput = {
  /** The answers to a question on the application form */
  answers: Array<ApplicationFormAnswerInput>;
  /** The identifier of the candidate, used to track the candidate through the application process */
  candidateTrackingId?: InputMaybe<Scalars["ID"]["input"]>;
  /** The google analytics client id of the applicant */
  googleAnalyticsClientId: Scalars["ID"]["input"];
  /** The date time (in ISO-8601 format) the applicant gave consent to store their data */
  hasGivenConsentAt: Scalars["String"]["input"];
  /** The unique identifier of the vacancy the applicant is applying for */
  vacancyId: Scalars["ID"]["input"];
  /** The ATS (and which api) is the source of the vacancy */
  atsSource: Maybe<AtsSource>;
};

/** The result of applying for a vacancy */
export type ApplyForVacancyResult =
  | ApplyForVacancyFailure
  | ApplyForVacancySuccess;

/** The success result of applying for a vacancy */
export type ApplyForVacancySuccess = {
  __typename?: "ApplyForVacancySuccess";
  /** The unique identifier of the candidate */
  candidateId: Scalars["ID"]["output"];
  /** Whether the application was successful */
  success: Scalars["Boolean"]["output"];
};

/**
 * The input field for availability matrix.
 * In which users can fill in on which days and on what part of the day the are available.
 */
export type AvailabilityMatrixFormField = InputField & {
  __typename?: "AvailabilityMatrixFormField";
  /** The identifier of the form field */
  id: Scalars["ID"]["output"];
  /** The informational text that explains the function of the availability matrix */
  info: Scalars["String"]["output"];
  /** Should this question be a knockout question and lead to automatic rejection of the applicant */
  isKnockout?: Maybe<Scalars["Boolean"]["output"]>;
  /** The label of the input field */
  label: Scalars["String"]["output"];
  /** The validation rules of the input field */
  rules?: Maybe<ValidationRules>;
  /** The type of the input field */
  type: ApplicationFieldType;
};

/** The input for creating/updating a block. One and only one of the fields must be filled in. An error will be thrown if none or multiple fields are filled in. */
export type BlockInput = {
  /** The application block */
  application?: InputMaybe<ApplicationBlockInput>;
  /** The header block */
  header?: InputMaybe<HeaderBlockInput>;
  /** The image gallery block */
  imageGallery?: InputMaybe<ImageGalleryBlockInput>;
  /** The procedure explainer block */
  procedureExplainer?: InputMaybe<ProcedureExplainerBlockInput>;
  /** The recruiter banner block */
  recruiter?: InputMaybe<RecruiterBlockInput>;
  /** The section with images block */
  sectionWithImages?: InputMaybe<SectionWithImagesBlockInput>;
  /** The text block */
  text?: InputMaybe<TextBlockInput>;
};

/** All supported block types */
export enum BlockType {
  /** An application block */
  Application = "APPLICATION",
  /** A header block */
  Header = "HEADER",
  /** An image gallery block */
  ImageGallery = "IMAGE_GALLERY",
  /** A procedure explainer block */
  ProcedureExplainer = "PROCEDURE_EXPLAINER",
  /** A recruiter block */
  Recruiter = "RECRUITER",
  /** A section with images block */
  SectionWithImages = "SECTION_WITH_IMAGES",
  /** A text block */
  Text = "TEXT",
}

/** All supported call to actions */
export type CallToAction =
  | EmailCallToAction
  | ToBlockCallToAction
  | WhatsAppCallToAction;

/** A call to action. One and only one of the fields should be filled in. */
export type CallToActionInput = {
  /** The email call to action */
  email?: InputMaybe<EmailCallToActionInput>;
  /** The to block call to action */
  toBlock?: InputMaybe<ToBlockCallToActionInput>;
  /** The type of the call to action */
  type: CallToActionType;
  /** The WhatsApp call to action */
  whatsApp?: InputMaybe<WhatAppCallToActionInput>;
};

/** All call to action types */
export enum CallToActionType {
  /** An email call to action */
  Email = "EMAIL",
  /** A to block call to action */
  ToBlock = "TO_BLOCK",
  /** A whatsapp call to action */
  WhatsApp = "WHATS_APP",
}

/** The result of creating a page */
export type CreatePageResult = {
  __typename?: "CreatePageResult";
  /** The unique identifier of the page */
  id: Scalars["ID"]["output"];
  /**
   * Whether the creation was successful
   * @deprecated An unsuccessful creation will throw an error and not return a result
   */
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

/** The input for creating a vacancy detail page */
export type CreateVacancyDetailPageInput = {
  /** The blocks of the page */
  blocks: Array<BlockInput>;
  /** The vacancy that the page is for */
  vacancyId: Scalars["ID"]["input"];
};

/** The input for creating a vacancy group detail page */
export type CreateVacancyGroupDetailPageInput = {
  /** The unique identifier of the group the page is for */
  groupId: Scalars["ID"]["input"];
  /** The slug of the vacancy group detail page */
  slug: Scalars["String"]["input"];
};

/** The input for creating a vacancy group */
export type CreateVacancyGroupInput = {
  /** The name of the group */
  name: Scalars["String"]["input"];
};

/** The result of creating a vacancy group */
export type CreateVacancyGroupResult = {
  __typename?: "CreateVacancyGroupResult";
  /** The unique identifier of the vacancy group */
  id?: Maybe<Scalars["ID"]["output"]>;
  /** Whether the update was successful */
  success: Scalars["Boolean"]["output"];
};

/** The result of deleting a page */
export type DeletePageResult = {
  __typename?: "DeletePageResult";
  /** Whether delete was successful */
  success: Scalars["Boolean"]["output"];
};

/** The input for creating/updating a description block */
export type DescriptionBlockInput = {
  /** The call to action of the block */
  callToAction: CallToActionInput;
  /** The unique identifier of the block */
  id: Scalars["ID"]["input"];
  /** The text of the block */
  text: Scalars["String"]["input"];
  /** The type of the block */
  type: BlockType;
};

/** An input type that supports multiple types. Only one of the fields should be filled in. */
export type DynamicInput = {
  /** A base64 encoded binary value */
  binary?: InputMaybe<Scalars["String"]["input"]>;
  /** The boolean value */
  boolean?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The float value */
  float?: InputMaybe<Scalars["Float"]["input"]>;
  /** A matrix input contains a list of columns which in turn contains rows of values */
  matrix?: InputMaybe<Array<MatrixColumnInput>>;
  /** The string value */
  string?: InputMaybe<Scalars["String"]["input"]>;
};

/** The available levels of education */
export enum EducationLevel {
  /** MBO/Professionele bachelor/Abgeschlossene Ausbildung/ */
  First = "FIRST",
  /** No education required */
  None = "NONE",
  /** HBO */
  Second = "SECOND",
  /** WO */
  Third = "THIRD",
}

/**
 * The education level name for a specific education level.
 * The name is localized to specified subsidiary and language.
 */
export type EducationLevelName = {
  __typename?: "EducationLevelName";
  /** The code of the education level */
  educationLevel: EducationLevel;
  /** The localized name of the education level */
  name: Scalars["String"]["output"];
};

/** Call to action */
export type EmailCallToAction = {
  __typename?: "EmailCallToAction";
  /** The email address to send the email to */
  email?: Maybe<Scalars["String"]["output"]>;
  /** The text of the call to action */
  text?: Maybe<Scalars["String"]["output"]>;
  /** The type of the call to action */
  type: CallToActionType;
};

/** The input for creating/updating an email call to action */
export type EmailCallToActionInput = {
  /** The email address */
  email?: InputMaybe<Scalars["String"]["input"]>;
  /** The text of the call to action */
  text?: InputMaybe<Scalars["String"]["input"]>;
  /** The type of the call to action */
  type: CallToActionType;
};

/** A fact and a slogan */
export type FactSlogan = {
  __typename?: "FactSlogan";
  /** A fact */
  fact?: Maybe<Scalars["String"]["output"]>;
  /** A slogan */
  slogan?: Maybe<Scalars["String"]["output"]>;
};

/** A fact and a slogan */
export type FactSloganInput = {
  /** A fact */
  fact?: InputMaybe<Scalars["String"]["input"]>;
  /** A slogan */
  slogan?: InputMaybe<Scalars["String"]["input"]>;
};

/** A file form field */
export type FileFormField = InputField & {
  __typename?: "FileFormField";
  /** The unique identifier of the input field if the input field is unique */
  id: Scalars["ID"]["output"];
  /** Should this question be a knockout question and lead to automatic rejection of the applicant */
  isKnockout?: Maybe<Scalars["Boolean"]["output"]>;
  /** The label of the input field */
  label: Scalars["String"]["output"];
  /** The validation rules of the input field */
  rules?: Maybe<ValidationRules>;
  /** The step indicator that the field belongs to */
  stepIndicator?: Maybe<ApplicationFormStepIndicator>;
  /** The title of the input field as shown on the button */
  title?: Maybe<Scalars["String"]["output"]>;
  /** The type of the input field */
  type: ApplicationFieldType;
};

/** Indicates in what way a candidate might expect a follow up after applying */
export enum FollowUpFlow {
  /** No specific follow up flow configured */
  None = "None",
  /** Spotler is used to send whatsapp messages to the candidate */
  Spotler = "Spotler",
}

/** The available functions */
export enum Function {
  /** Commercial */
  Commercial = "COMMERCIAL",
  /** Data and analytics */
  DataAndAnalytics = "DATA_AND_ANALYTICS",
  /** Facility */
  Facility = "FACILITY",
  /** Finance */
  Finance = "FINANCE",
  /** HR */
  Hr = "HR",
  /** Installation */
  Installation = "INSTALLATION",
  /** IT */
  It = "IT",
  /** Legal */
  Legal = "LEGAL",
  /** Logistics */
  Logistics = "LOGISTICS",
  /** Marketing & communication */
  MarketingAndCommunication = "MARKETING_AND_COMMUNICATION",
  /** Tech */
  Tech = "TECH",
}

/** A group of input fields */
export type GroupFormField = {
  __typename?: "GroupFormField";
  /** The group of input fields */
  fields: Array<ApplicationFormField>;
  /** The step indicator that the field belongs to */
  stepIndicator?: Maybe<ApplicationFormStepIndicator>;
  /** The type of the input field */
  type: ApplicationFieldType;
};

/** A header block */
export type HeaderBlock = {
  __typename?: "HeaderBlock";
  /** The description of the header */
  description?: Maybe<Scalars["String"]["output"]>;
  /** The unique identifier of the block */
  id: Scalars["ID"]["output"];
  /** The title of the header */
  title?: Maybe<Scalars["String"]["output"]>;
  /** The type of the block */
  type: BlockType;
};

/** The input for creating/updating a header block */
export type HeaderBlockInput = {
  /** The description of the header block */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** The unique identifier of the block */
  id: Scalars["ID"]["input"];
  /** The title of the block */
  title?: InputMaybe<Scalars["String"]["input"]>;
  /** The type of the block */
  type: BlockType;
};

/** The input for creating/updating a hero banner block */
export type HeroBannerBlockInput = {
  /** The hours of a hero banner block */
  hours: HoursInput;
  /** The unique identifier of the block */
  id: Scalars["ID"]["input"];
  /** The image of a hero banner block */
  image: ImageByDeviceInput;
  /** The location of a hero banner block. This location is required for the VacancyDetailPage type */
  location?: InputMaybe<LocationInput>;
  /** The title of a hero banner block */
  title: Scalars["String"]["input"];
  /** The type of the block */
  type: BlockType;
};

/** The input for hours */
export type HoursInput = {
  /** The maximum hours of a vacancy */
  max: Scalars["Int"]["input"];
  /** The minimum hours of a vacancy */
  min: Scalars["Int"]["input"];
};

/** The minimum and maximum of working hours of a vacancy */
export type HoursRange = {
  __typename?: "HoursRange";
  /** The maximum working hours of a vacancy */
  max?: Maybe<Scalars["Int"]["output"]>;
  /** The minimum working hours of a vacancy */
  min?: Maybe<Scalars["Int"]["output"]>;
};

/** The working hours of a vacancy */
export type HoursUnion = HoursRange;

/** An image that is stored in Flirt */
export type Image = {
  __typename?: "Image";
  /** The alt text of the image */
  alt?: Maybe<Scalars["String"]["output"]>;
  /** The unique identifier of the image in Flirt */
  id?: Maybe<Scalars["ID"]["output"]>;
};

/** An image that is stored in Flirt and can be displayed on different devices */
export type ImageByDevice = {
  __typename?: "ImageByDevice";
  /** The image to show on desktop devices */
  desktop?: Maybe<Image>;
  /** The image to show on mobile devices */
  mobile?: Maybe<Image>;
};

/** The input for creating/updating an image */
export type ImageByDeviceInput = {
  /** The image to show on desktop devices */
  desktop?: InputMaybe<ImageInput>;
  /** The image to show on mobile devices. The desktop image is used for mobile if this field is not filled in. */
  mobile?: InputMaybe<ImageInput>;
};

/** An image gallery block */
export type ImageGalleryBlock = {
  __typename?: "ImageGalleryBlock";
  /** The unique identifier of the block */
  id: Scalars["ID"]["output"];
  /** The images of the block */
  images: Array<ImageByDevice>;
  /** The type of the block */
  type: BlockType;
};

/** The input for creating/updating an image gallery block */
export type ImageGalleryBlockInput = {
  /** The unique identifier of the block */
  id: Scalars["ID"]["input"];
  /** The images of the section */
  images: Array<ImageByDeviceInput>;
  /** The type of the block */
  type: BlockType;
};

/** The input for creating/updating an image */
export type ImageInput = {
  /** The alt text of the image */
  alt?: InputMaybe<Scalars["String"]["input"]>;
  /** The unique identifier of the image in Flirt */
  id?: InputMaybe<Scalars["ID"]["input"]>;
};

/** The contract for an input field */
export type InputField = {
  /** The unique identifier of the input field if the input field is unique */
  id: Scalars["ID"]["output"];
  /** Should this question be a knockout question and lead to automatic rejection of the applicant */
  isKnockout?: Maybe<Scalars["Boolean"]["output"]>;
  /** The label of the input field */
  label: Scalars["String"]["output"];
};

/** The available job types */
export enum JobType {
  /** Holiday job */
  HolidayJob = "HOLIDAY_JOB",
  /** Internship */
  Internship = "INTERNSHIP",
  /** Regular job */
  RegularJob = "REGULAR_JOB",
  /** Side job */
  SideJob = "SIDE_JOB",
}

/** All supported language codes */
export enum LanguageCode {
  /** German */
  De = "de",
  /** English */
  En = "en",
  /** French */
  Fr = "fr",
  /** Netherlands */
  Nl = "nl",
}

/** A physical location possibly related to a vacancy */
export type Location = {
  __typename?: "Location";
  /** The city of the location */
  city: Scalars["String"]["output"];
  /** The display name of the location */
  displayName: Scalars["String"]["output"];
  /** The unique identifier of the location */
  id: Scalars["ID"]["output"];
  /** The name of the location */
  name: Scalars["String"]["output"];
};

/** The input for creating/updating a location */
export type LocationInput = {
  /** The unique identifier of the location */
  id: Scalars["ID"]["input"];
};

/**
 * A column in a matrix input
 * Contains a label and a list of rows for that column
 */
export type MatrixColumnInput = {
  /** The label of the column */
  label: Scalars["String"]["input"];
  /** The rows of the column */
  rows: Array<MatrixRowInput>;
};

/**
 * A row in a matrix input
 * Contains a label and a list of values for that row
 */
export type MatrixRowInput = {
  /** The label of the row */
  label: Scalars["String"]["input"];
  /** The value of the row */
  value: Scalars["Boolean"]["input"];
};

export type Mutation = {
  __typename?: "Mutation";
  /** Apply for a vacancy */
  applyForVacancy?: Maybe<ApplyForVacancyResult>;
  /** Create a vacancy detail page. E.g. magazijnmedewerker */
  createVacancyDetailPage?: Maybe<CreatePageResult>;
  /** Create a vacancy group */
  createVacancyGroup?: Maybe<CreateVacancyGroupResult>;
  /** Create a vacancy group detail page. E.g. bezorger */
  createVacancyGroupDetailPage?: Maybe<CreatePageResult>;
  /** Delete a DynamoDB item */
  deleteBackendDDBItem?: Maybe<Scalars["Boolean"]["output"]>;
  /** Delete a page */
  deletePage?: Maybe<DeletePageResult>;
  /** Publish multiple pages at once. This will set the status of the pages to published and update the published date. */
  publishPages?: Maybe<PublishPagesResult>;
  /**
   * Render vacancy content preview (HTML) for a given preview
   * @deprecated No longer support the preview feature
   */
  renderVacancyContentPreviewHtml?: Maybe<Scalars["String"]["output"]>;
  /** Unpublish multiple pages at once. This will set the status of the pages to unpublished. */
  unpublishPages?: Maybe<PublishPagesResult>;
  /** Update the slug of a page, use this only to fix slug issues. */
  updateSlug?: Maybe<UpdateSlugResult>;
  /** Update a vacancy */
  updateVacancy?: Maybe<UpdateVacancyResult>;
  /** Update an existing vacancy detail page. E.g. magazijnmedewerker */
  updateVacancyDetailPage?: Maybe<UpdatePageResult>;
  /** Update an existing vacancy group detail page. E.g. bezorger */
  updateVacancyGroupDetailPage?: Maybe<UpdatePageResult>;
};

export type MutationApplyForVacancyArgs = {
  input: ApplyForVacancyInput;
  language?: InputMaybe<LanguageCode>;
  subsidiary?: InputMaybe<SubsidiaryCode>;
};

export type MutationCreateVacancyDetailPageArgs = {
  input: CreateVacancyDetailPageInput;
  language?: InputMaybe<LanguageCode>;
  subsidiary?: InputMaybe<SubsidiaryCode>;
};

export type MutationCreateVacancyGroupArgs = {
  input: CreateVacancyGroupInput;
  subsidiary?: InputMaybe<SubsidiaryCode>;
};

export type MutationCreateVacancyGroupDetailPageArgs = {
  input: CreateVacancyGroupDetailPageInput;
  language: LanguageCode;
  subsidiary: SubsidiaryCode;
};

export type MutationDeleteBackendDdbItemArgs = {
  pk: Scalars["String"]["input"];
  sk: Scalars["String"]["input"];
};

export type MutationDeletePageArgs = {
  id: Scalars["ID"]["input"];
  languageCode: LanguageCode;
  subsidiaryCode: SubsidiaryCode;
};

export type MutationPublishPagesArgs = {
  pages: Array<PublishPageInput>;
};

export type MutationRenderVacancyContentPreviewHtmlArgs = {
  previewId: Scalars["ID"]["input"];
};

export type MutationUnpublishPagesArgs = {
  pages: Array<PublishPageInput>;
};

export type MutationUpdateSlugArgs = {
  language: LanguageCode;
  newSlug: Scalars["String"]["input"];
  pageId: Scalars["String"]["input"];
  subsidiary: SubsidiaryCode;
};

export type MutationUpdateVacancyArgs = {
  id: Scalars["ID"]["input"];
  input: UpdateVacancyInput;
  subsidiary?: InputMaybe<SubsidiaryCode>;
};

export type MutationUpdateVacancyDetailPageArgs = {
  id: Scalars["ID"]["input"];
  input: UpdateVacancyDetailPageInput;
  language?: InputMaybe<LanguageCode>;
  subsidiary?: InputMaybe<SubsidiaryCode>;
};

export type MutationUpdateVacancyGroupDetailPageArgs = {
  id: Scalars["ID"]["input"];
  input: UpdateVacancyGroupDetailPageInput;
  language?: InputMaybe<LanguageCode>;
  subsidiary?: InputMaybe<SubsidiaryCode>;
};

/** The available statuses for pages */
export enum PageStatus {
  /** The page is in draft state and not yet visible to the public */
  Draft = "DRAFT",
  /** The page is published and visible to the public */
  Published = "PUBLISHED",
  /** The page is no longer published and currently not visible to the public, the frontend should show a message that the vacancy is no longer available */
  Unpublished = "UNPUBLISHED",
}

/** All supported page types */
export enum PageType {
  /** A vacancy detail page */
  VacancyDetail = "VACANCY_DETAIL",
  /** A vacancy group detail page */
  VacancyGroupDetail = "VACANCY_GROUP_DETAIL",
}

/** A procedure explainer block */
export type ProcedureExplainerBlock = {
  __typename?: "ProcedureExplainerBlock";
  /** The unique identifier of the block */
  id: Scalars["ID"]["output"];
  /** The steps explaining the procedure */
  steps?: Maybe<Array<ProcedureExplainerStep>>;
  /** The title of the block */
  title?: Maybe<Scalars["String"]["output"]>;
  /** The type of the block */
  type: BlockType;
};

/** The input for creating/updating a procedure explainer block */
export type ProcedureExplainerBlockInput = {
  /** The unique identifier of the block */
  id: Scalars["ID"]["input"];
  /** The procedure explainer steps of the block */
  steps?: InputMaybe<Array<ProcedureExplainerStepInput>>;
  /** The title of a BannerBlock */
  title?: InputMaybe<Scalars["String"]["input"]>;
  /** The type of the block */
  type: BlockType;
};

/** A procedure explainer step containing information about the hiring procedure */
export type ProcedureExplainerStep = {
  __typename?: "ProcedureExplainerStep";
  /** The description of the step */
  description?: Maybe<Scalars["String"]["output"]>;
  /** The fact and slogan of the step */
  factSlogan?: Maybe<FactSlogan>;
  /** The image of the step */
  image?: Maybe<ImageByDevice>;
};

/** The input for creating/updating a Procedure explainer step */
export type ProcedureExplainerStepInput = {
  /** The description of the step */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** The fact slogan of the step */
  factSlogan?: InputMaybe<FactSloganInput>;
  /** The image of the step */
  image?: InputMaybe<ImageByDeviceInput>;
};

/** The input needed to find a page and set its status to published. */
export type PublishPageInput = {
  /** The identifier of the page to publish */
  id: Scalars["ID"]["input"];
  /** The language code of the page to publish */
  language: LanguageCode;
  /** The subsidiary code of the page to publish */
  subsidiary: SubsidiaryCode;
};

/** The result wether all pages were published successfully */
export type PublishPagesResult = {
  __typename?: "PublishPagesResult";
  /** Whether the publish was successful */
  success: Scalars["Boolean"]["output"];
};

export type Query = {
  __typename?: "Query";
  /** List all locations */
  allLocations?: Maybe<Array<Location>>;
  /** List all screening questions */
  allScreeningQuestions?: Maybe<Array<ScreeningQuestion>>;
  /** List all text block titles */
  allTextBlockTitles?: Maybe<Array<TextBlockTitle>>;
  /** Find a job from the ATS by its id. */
  atsVacancy?: Maybe<SmartRecruitersJob>;
  /** List all names of the education levels in specified language */
  educationLevels?: Maybe<Array<EducationLevelName>>;
  /** List all jobs from SmartRecruiters. Even though the query is called vacancies, it only returns jobs from SmartRecruiters. */
  vacancies?: Maybe<Array<SmartRecruitersJob>>;
  /** Find a vacancy by its id */
  vacancy?: Maybe<Vacancy>;
  /** List all vacancy detail page summaries */
  vacancyDetailPageSummaries?: Maybe<Array<VacancyDetailPageSummary>>;
  /** Find a vacancy group by its id */
  vacancyGroup?: Maybe<VacancyGroup>;
  /** List all vacancy group detail page summaries */
  vacancyGroupDetailPageSummaries?: Maybe<Array<VacancyGroupDetailPageSummary>>;
  /** Check if a certain slug is available to be used */
  verifySlug?: Maybe<VerifySlugResponse>;
};

export type QueryAllLocationsArgs = {
  languageCode?: LanguageCode;
  subsidiaryCode?: SubsidiaryCode;
};

export type QueryAllScreeningQuestionsArgs = {
  languageCode?: LanguageCode;
  subsidiaryCode?: SubsidiaryCode;
};

export type QueryAllTextBlockTitlesArgs = {
  languageCode?: InputMaybe<LanguageCode>;
  subsidiaryCode?: InputMaybe<SubsidiaryCode>;
};

export type QueryAtsVacancyArgs = {
  id: Scalars["ID"]["input"];
  source?: InputMaybe<AtsSource>;
};

export type QueryEducationLevelsArgs = {
  language: LanguageCode;
  subsidiary: SubsidiaryCode;
};

export type QueryVacanciesArgs = {
  internal?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryVacancyArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryVacancyGroupArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryVerifySlugArgs = {
  languageCode?: InputMaybe<LanguageCode>;
  slug: Scalars["String"]["input"];
  subsidiaryCode: SubsidiaryCode;
};

/** All available radio group directions */
export enum RadioDirection {
  /** The radio buttons are displayed in a column */
  Column = "COLUMN",
  /** The radio buttons are displayed in a row */
  Row = "ROW",
}

/** A radio button field of a radio group input field */
export type RadioField = {
  __typename?: "RadioField";
  /** The label of the radio field */
  label: Scalars["String"]["output"];
  /** The name of the radio field */
  name: Scalars["String"]["output"];
  /** The value of the radio field */
  value: Scalars["String"]["output"];
};

/** A radio group field */
export type RadioGroupFormField = InputField & {
  __typename?: "RadioGroupFormField";
  /** The radio buttons direction */
  direction: RadioDirection;
  /** The unique identifier of the input field if the input field is unique */
  id: Scalars["ID"]["output"];
  /** Should this question be a knockout question and lead to automatic rejection of the applicant */
  isKnockout?: Maybe<Scalars["Boolean"]["output"]>;
  /** The label of the input field */
  label: Scalars["String"]["output"];
  /** All radio fields of the radio group */
  radioFields?: Maybe<Array<RadioField>>;
  /** The validation rules of the input field */
  rules?: Maybe<ValidationRules>;
  /** The step indicator that the field belongs to */
  stepIndicator?: Maybe<ApplicationFormStepIndicator>;
  /** The type of the input field */
  type: ApplicationFieldType;
};

/** The input for the ranged working hours */
export type RangedWorkingHoursInput = {
  /** The maximum hours */
  max?: InputMaybe<Scalars["Int"]["input"]>;
  /** The minimum hours */
  min?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The recruiter responsible for a vacancy */
export type Recruiter = {
  __typename?: "Recruiter";
  /** The image of the recruiter. TODO: This should be a union type of Image and ImageByDevice */
  image?: Maybe<ImageByDevice>;
  /** The name of the recruiter */
  name?: Maybe<Scalars["String"]["output"]>;
  /** The slogan of the recruiter */
  text?: Maybe<Scalars["String"]["output"]>;
};

/** A recruiter block */
export type RecruiterBlock = {
  __typename?: "RecruiterBlock";
  /** The call to actions of the block */
  callToActions?: Maybe<Array<CallToAction>>;
  /** The unique identifier of the block */
  id: Scalars["ID"]["output"];
  /** The recruiter information */
  recruiter?: Maybe<Recruiter>;
  /** The type of the block */
  type: BlockType;
};

/** The input for creating/updating a recruiter block */
export type RecruiterBlockInput = {
  /** The call to actions of the block */
  callToActions?: InputMaybe<Array<CallToActionInput>>;
  /** The unique identifier of the block */
  id: Scalars["ID"]["input"];
  /** The recruiter information */
  recruiter?: InputMaybe<RecruiterInput>;
  /** The type of the block */
  type: BlockType;
};

/** The input for creating/updating a Recruiter */
export type RecruiterInput = {
  /** The image of the recruiter */
  image?: InputMaybe<ImageByDeviceInput>;
  /** The name of the recruiter */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** The text of the recruiter */
  text?: InputMaybe<Scalars["String"]["input"]>;
};

/** Search engine optimization fields */
export type Seo = {
  __typename?: "SEO";
  /** The canonical URL of the page */
  canonicalUrl?: Maybe<Scalars["String"]["output"]>;
  /** The meta description of the page */
  metaDescription?: Maybe<Scalars["String"]["output"]>;
};

/** A hourly salary defined as a fixed value */
export type SalaryFixedHourly = {
  __typename?: "SalaryFixedHourly";
  /** The fixed value of the salary */
  value: Scalars["Float"]["output"];
};

/** The input for a salary defined by a fixed value */
export type SalaryFixedInput = {
  /** The type of the salary */
  type: SalaryPaymentType;
  /** The fixed value of the salary */
  value: Scalars["Float"]["input"];
};

/** A monthly salary defined as a fixed value */
export type SalaryFixedMonthly = {
  __typename?: "SalaryFixedMonthly";
  /** The fixed value of the salary */
  value: Scalars["Float"]["output"];
};

/** The input for a salary */
export type SalaryInput = {
  /** The fixed salary of the vacancy */
  fixed?: InputMaybe<SalaryFixedInput>;
  /** The range salary of the vacancy */
  range?: InputMaybe<SalaryRangeInput>;
};

/** The payment type that salary is defined by */
export enum SalaryPaymentType {
  /** Hourly */
  Hourly = "HOURLY",
  /** Monthly */
  Monthly = "MONTHLY",
}

/** A hourly salary defined as a range */
export type SalaryRangeHourly = {
  __typename?: "SalaryRangeHourly";
  /** The maximum value of the range */
  max: Scalars["Float"]["output"];
  /** The minimum value of the range */
  min: Scalars["Float"]["output"];
};

/** The input for a salary defined by a range */
export type SalaryRangeInput = {
  /** The maximum value of the salary */
  max: Scalars["Float"]["input"];
  /** The minimum value of the salary */
  min: Scalars["Float"]["input"];
  /** The type of the salary */
  type: SalaryPaymentType;
};

/** A monthly salary defined as a range */
export type SalaryRangeMonthly = {
  __typename?: "SalaryRangeMonthly";
  /** The maximum value of the range */
  max: Scalars["Float"]["output"];
  /** The minimum value of the range */
  min: Scalars["Float"]["output"];
};

/** All supported salary types */
export type SalaryUnion =
  | SalaryFixedHourly
  | SalaryFixedMonthly
  | SalaryRangeHourly
  | SalaryRangeMonthly;

/** A question that is asked to the applicant to screen them */
export type ScreeningQuestion = {
  __typename?: "ScreeningQuestion";
  /** Determines if this screening question CAN be a knockout question. */
  canBeKnockout: Scalars["Boolean"]["output"];
  /** The name of the category that the screening question belongs to */
  categoryName: Scalars["String"]["output"];
  /** The unique identifier (generated by SmartRecruiters) of the screening question */
  id: Scalars["ID"]["output"];
  /** The screening question */
  label: Scalars["String"]["output"];
  /** The language code of the screening question */
  languageCode: LanguageCode;
  /** The subsidiary code of the screening question */
  subsidiaryCode: SubsidiaryCode;
};

/** A section block */
export type SectionWithImagesBlock = {
  __typename?: "SectionWithImagesBlock";
  /** The unique identifier of the block */
  id: Scalars["ID"]["output"];
  /** The images of the block */
  images: Array<ImageByDevice>;
  /** The title of the block */
  title?: Maybe<Scalars["String"]["output"]>;
  /** The type of the block */
  type: BlockType;
  /** The side usps */
  uspsSide: UspsSide;
};

/** The input for creating/updating a section block */
export type SectionWithImagesBlockInput = {
  /** The unique identifier of the block */
  id: Scalars["ID"]["input"];
  /** The images of the section */
  images: Array<ImageByDeviceInput>;
  /** The title of a BannerBlock */
  title?: InputMaybe<Scalars["String"]["input"]>;
  /** The type of the block */
  type: BlockType;
  /** The usps of the section */
  uspsSide: UspsSideInput;
};

/** All the supported usp types */
export enum SideUspsType {
  /** Usps on the left side */
  Left = "LEFT",
  /** Usps on the right side */
  Right = "RIGHT",
}

/** A job (vacancy) in SmartRecruiters */
export type SmartRecruitersJob = {
  __typename?: "SmartRecruitersJob";
  /** The unique identifier of the vacancy */
  id: Scalars["String"]["output"];
  /** Whether the job is internal only */
  internal: Scalars["Boolean"]["output"];
  /** A job reference number in SmartRecruiters */
  refNumber: Scalars["String"]["output"];
  /** The source of the job */
  source: AtsSource;
  /** The title of the job */
  title: Scalars["String"]["output"];
};

/** All supported subsidiary (country) codes */
export enum SubsidiaryCode {
  /** Belgium */
  Be = "be",
  /** Germany */
  De = "de",
  /** Netherlands */
  Nl = "nl",
}

/** A text area field */
export type TextAreaFormField = InputField & {
  __typename?: "TextAreaFormField";
  /** The unique identifier of the input field if the input field is unique */
  id: Scalars["ID"]["output"];
  /** Should this question be a knockout question and lead to automatic rejection of the applicant */
  isKnockout?: Maybe<Scalars["Boolean"]["output"]>;
  /** The label of the input field */
  label: Scalars["String"]["output"];
  /** The placeholder of the input field */
  placeholder?: Maybe<Scalars["String"]["output"]>;
  /** The validation rules of the input field */
  rules?: Maybe<ValidationRules>;
  /** The step indicator that the field belongs to */
  stepIndicator?: Maybe<ApplicationFormStepIndicator>;
  /** The type of the input field */
  type: ApplicationFieldType;
};

/** A text block */
export type TextBlock = {
  __typename?: "TextBlock";
  /** The unique identifier of the block */
  id: Scalars["ID"]["output"];
  /** The text of the block. Is only nullable when page has DRAFT status */
  text?: Maybe<Scalars["String"]["output"]>;
  /** The title ID of the block. Is only nullable when page has DRAFT status */
  titleId?: Maybe<Scalars["ID"]["output"]>;
  /** The type of the block */
  type: BlockType;
};

/** The input for creating/updating a text block */
export type TextBlockInput = {
  /** The unique identifier of the block */
  id: Scalars["ID"]["input"];
  /** The text of a TextBlock */
  text?: InputMaybe<Scalars["String"]["input"]>;
  /** The title id of a TextBlock */
  titleId?: InputMaybe<Scalars["ID"]["input"]>;
  /** The type of the block */
  type: BlockType;
};

/** A title of a text block */
export type TextBlockTitle = {
  __typename?: "TextBlockTitle";
  /** The unique identifier of the title */
  id: Scalars["ID"]["output"];
  /** The language code of the title */
  languageCode: LanguageCode;
  /** The subsidiary code of the title */
  subsidiaryCode: SubsidiaryCode;
  /** The text of the title */
  text: Scalars["String"]["output"];
};

/** A text form field */
export type TextFormField = InputField & {
  __typename?: "TextFormField";
  /** The unique identifier of the input field if the input field is unique */
  id: Scalars["ID"]["output"];
  /** Should this question be a knockout question and lead to automatic rejection of the applicant */
  isKnockout?: Maybe<Scalars["Boolean"]["output"]>;
  /** The label of the input field */
  label: Scalars["String"]["output"];
  /** The placeholder of the input field */
  placeholder?: Maybe<Scalars["String"]["output"]>;
  /** The validation rules of the input field */
  rules?: Maybe<ValidationRules>;
  /** The step indicator that the field belongs to */
  stepIndicator?: Maybe<ApplicationFormStepIndicator>;
  /** The type of the input field */
  type: ApplicationFieldType;
};

/** Call to action */
export type ToBlockCallToAction = {
  __typename?: "ToBlockCallToAction";
  /** The unique identifier of the block to navigate to */
  blockId?: Maybe<Scalars["ID"]["output"]>;
  /** The text of the call to action */
  text?: Maybe<Scalars["String"]["output"]>;
  /** The type of the call to action */
  type: CallToActionType;
};

/** The input for creating/updating a to block call to action */
export type ToBlockCallToActionInput = {
  /** The unique identifier of the block */
  blockId?: InputMaybe<Scalars["ID"]["input"]>;
  /** The text of the call to action */
  text?: InputMaybe<Scalars["String"]["input"]>;
  /** The type of the call to action */
  type: CallToActionType;
};

/** The result of updating a vacancy detail page */
export type UpdatePageResult = {
  __typename?: "UpdatePageResult";
  /** Whether the update was successful */
  success: Scalars["Boolean"]["output"];
};

/** The result of updating a slug */
export type UpdateSlugResult = {
  __typename?: "UpdateSlugResult";
  /** Whether the operation was successful */
  success: Scalars["Boolean"]["output"];
};

/** The input for updating a vacancy detail page */
export type UpdateVacancyDetailPageInput = {
  /** The blocks of the page */
  blocks: Array<BlockInput>;
  /** The vacancy that the page is for */
  vacancyId: Scalars["ID"]["input"];
};

/** The input for updating a vacancy group detail page */
export type UpdateVacancyGroupDetailPageInput = {
  /** The blocks of the page */
  blocks: Array<BlockInput>;
  /** The unique identifier of the group the page is for */
  groupId: Scalars["ID"]["input"];
};

/** The input for updating a vacancy */
export type UpdateVacancyInput = {
  /** The required educational level of the vacancy */
  educationLevels?: InputMaybe<Array<EducationLevel>>;
  /** Indicates if this vacancy has a specific follow up flow configured. This would help us to inform that candidate on what to expect next */
  followUpFlow?: InputMaybe<FollowUpFlow>;
  /** What function this vacancy is for */
  functions?: InputMaybe<Array<Function>>;
  /** The unique identifier of the group the vacancy belongs to */
  groupId?: InputMaybe<Scalars["ID"]["input"]>;
  /** The working hours of the vacancy */
  hours?: InputMaybe<WorkingHoursInput>;
  /** Whether this is an internal vacancy */
  internal?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Is this a vacancy in the Coolblue Energy domain */
  isCoolblueEnergy?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The type of job this vacancy is for */
  jobTypes?: InputMaybe<Array<JobType>>;
  /** The location of the vacancy */
  locationId?: InputMaybe<Scalars["ID"]["input"]>;
  /** The reference to the job vacancy in the Applicant Tracking System */
  refNumber?: InputMaybe<Scalars["String"]["input"]>;
  /** Whether this vacancy offers relocation possibilities for foreign candidates */
  relocationPossible?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The salary of the vacancy */
  salary?: InputMaybe<SalaryInput>;
  /** The source of the vacancy */
  source?: InputMaybe<AtsSource>;
  /** The working areas of this job */
  workingAreas?: InputMaybe<Array<WorkArea>>;
};

/** The result of updating a vacancy */
export type UpdateVacancyResult = {
  __typename?: "UpdateVacancyResult";
  /** Whether the update was successful */
  success: Scalars["Boolean"]["output"];
};

/** A side usp */
export type UspsSide = {
  __typename?: "UspsSide";
  /** The type of the side usps */
  type: SideUspsType;
  /** The usp text */
  usps: Array<Scalars["String"]["output"]>;
};

/** The input for creating/updating side usps */
export type UspsSideInput = {
  /** The type of the side USP */
  type: SideUspsType;
  /** The USP text */
  usps: Array<Scalars["String"]["input"]>;
};

/** A vacancy (job) that someone can apply for */
export type Vacancy = {
  __typename?: "Vacancy";
  /** The required educational level of the vacancy */
  educationLevels?: Maybe<Array<EducationLevel>>;
  /** Indicates if this vacancy has a specific follow up flow configured. This would help us to inform that candidate on what to expect next */
  followUpFlow?: Maybe<FollowUpFlow>;
  /** What function this vacancy is for */
  functions?: Maybe<Array<Function>>;
  /** The ID of the vacancy group the vacancy belongs to */
  groupId?: Maybe<Scalars["ID"]["output"]>;
  /** The hours of the vacancy */
  hours?: Maybe<HoursUnion>;
  /** The unique identifier of the vacancy */
  id: Scalars["ID"]["output"];
  /** Is this a vacancy in the Coolblue Energy domain */
  isCoolblueEnergy?: Maybe<Scalars["Boolean"]["output"]>;
  /** The type of job this vacancy is for */
  jobTypes?: Maybe<Array<JobType>>;
  /** The location of the vacancy */
  location?: Maybe<Location>;
  /** The pages of the vacancy */
  pages: Array<VacancyDetailPage>;
  /** Whether this vacancy offers relocation possibilities for foreign candidates */
  relocationPossible?: Maybe<Scalars["Boolean"]["output"]>;
  /** The salary of the vacancy */
  salary?: Maybe<SalaryUnion>;
  /** The vacancy/job reference in SmartRecruiters */
  smartRecruiters?: Maybe<SmartRecruitersJob>;
  /** The working areas of this job */
  workingAreas?: Maybe<Array<WorkArea>>;
};

/** A vacancy detail page */
export type VacancyDetailPage = {
  __typename?: "VacancyDetailPage";
  /** The blocks of the page */
  blocks: Array<VacancyDetailPageBlock>;
  /** The title to show in the browser tab. Also used for SEO. This field only exists on pages which have been published at least once. */
  browserTitle?: Maybe<Scalars["String"]["output"]>;
  /** The ID of the group the vacancy belongs to */
  groupId?: Maybe<Scalars["ID"]["output"]>;
  /** Unique identifier of the page */
  id: Scalars["ID"]["output"];
  /** The language code of the page */
  languageCode: LanguageCode;
  /** The SEO related data of the page. This field only exists on pages which have been published at least once. */
  seo?: Maybe<Seo>;
  /** The slug of the page. This field only exists on pages which have been published at least once. */
  slug?: Maybe<Scalars["String"]["output"]>;
  /** The status of the page */
  status: PageStatus;
  /** The subsidiary of the page */
  subsidiaryCode: SubsidiaryCode;
  /** The type of the page */
  type: PageType;
  /** The vacancy of the page */
  vacancy: Vacancy;
};

/** All supported blocks for a vacancy detail page */
export type VacancyDetailPageBlock =
  | ApplicationBlock
  | HeaderBlock
  | ImageGalleryBlock
  | ProcedureExplainerBlock
  | RecruiterBlock
  | SectionWithImagesBlock
  | TextBlock;

/** A summary data of a vacancy detail page. Mainly used for listing purposes. */
export type VacancyDetailPageSummary = {
  __typename?: "VacancyDetailPageSummary";
  /** The unique identifier of the page */
  id: Scalars["ID"]["output"];
  /** The language code of the page */
  languageCode: LanguageCode;
  /** The slug of the page */
  slug?: Maybe<Scalars["String"]["output"]>;
  /** The status of the page */
  status: PageStatus;
  /** The subsidiary code of the page */
  subsidiaryCode: SubsidiaryCode;
  /** The vacancy of the page */
  vacancy: Vacancy;
};

/** A vacancy group */
export type VacancyGroup = {
  __typename?: "VacancyGroup";
  /** The unique identifier of the vacancy group */
  id: Scalars["ID"]["output"];
  /** The name of the group */
  name: Scalars["String"]["output"];
  /** The pages of the vacancy group */
  pages: Array<VacancyGroupDetailPage>;
  /** The salary of the vacancy group */
  salary?: Maybe<SalaryUnion>;
  /** The subsidiary code of the vacancy group */
  subsidiaryCode: SubsidiaryCode;
};

/** A vacancy group detail page */
export type VacancyGroupDetailPage = {
  __typename?: "VacancyGroupDetailPage";
  /** The blocks of the page */
  blocks: Array<VacancyGroupDetailPageBlock>;
  /** The title to show in the browser tab. Also used for SEO */
  browserTitle?: Maybe<Scalars["String"]["output"]>;
  /** Unique identifier of the page */
  id: Scalars["ID"]["output"];
  /** The language code of the page */
  languageCode: LanguageCode;
  /** The SEO related data of the page */
  seo?: Maybe<Seo>;
  /** The slug of the page */
  slug: Scalars["String"]["output"];
  /** The status of the page */
  status: PageStatus;
  /** The type of the page */
  type: PageType;
  /** The vacancy detail pages (children) of a vacancy group detail page */
  vacancyDetailPageSummaries?: Maybe<Array<VacancyDetailPageSummary>>;
  /** The group of the page */
  vacancyGroup: VacancyGroup;
};

/** All supported blocks for a vacancy group detail page */
export type VacancyGroupDetailPageBlock =
  | ApplicationBlock
  | HeaderBlock
  | ImageGalleryBlock
  | ProcedureExplainerBlock
  | RecruiterBlock
  | SectionWithImagesBlock
  | TextBlock;

/** A summary data of a vacancy group detail page. Mainly used for listing purposes. */
export type VacancyGroupDetailPageSummary = {
  __typename?: "VacancyGroupDetailPageSummary";
  /** The unique identifier of the page */
  id: Scalars["ID"]["output"];
  /** The language code of the page */
  languageCode: LanguageCode;
  /** The slug of the page */
  slug: Scalars["String"]["output"];
  /** The status of the page */
  status: PageStatus;
  /** The subsidiary code of the page */
  subsidiaryCode: SubsidiaryCode;
  /** The vacancy detail pages (children) of the group */
  vacancyDetailPageSummaries?: Maybe<Array<VacancyDetailPageSummary>>;
  /** The vacancy group of the page */
  vacancyGroup: VacancyGroup;
};

/** The contract for a Boolean validation rule */
export type ValidationBooleanRule = {
  __typename?: "ValidationBooleanRule";
  /** The validation failed message */
  message: Scalars["String"]["output"];
  /** The value of the validation rule */
  value: Scalars["Boolean"]["output"];
};

/** The contract for a Boolean validation rule */
export type ValidationFailed = {
  __typename?: "ValidationFailed";
  /** The validation failed message */
  message: Scalars["String"]["output"];
};

/** The contract for an Integer validation rule */
export type ValidationIntRule = {
  __typename?: "ValidationIntRule";
  /** The validation failed message */
  message: Scalars["String"]["output"];
  /** The value of the validation rule */
  value: Scalars["Int"]["output"];
};

/** All validation rules */
export type ValidationRules = {
  __typename?: "ValidationRules";
  /** The validation rule for the maximum length of the input */
  max?: Maybe<ValidationIntRule>;
  /** The validation rule for the minimum length of the input */
  min?: Maybe<ValidationIntRule>;
  /** The required validation rule */
  required?: Maybe<ValidationBooleanRule>;
  /** The validation rule for the pattern of the input */
  validate?: Maybe<ValidationFailed>;
};

/** Contains information about the availability of a slug */
export type VerifySlugResponse = {
  __typename?: "VerifySlugResponse";
  /** True when the slug can be used, false if it is already taken */
  available: Scalars["Boolean"]["output"];
  /** The pageId of the page that has reserved the slug */
  pageId?: Maybe<Scalars["String"]["output"]>;
  /** The vacancyId of the page that has reserved the slug */
  vacancyId?: Maybe<Scalars["String"]["output"]>;
};

/** The input for creating/updating a WhatsApp call to action */
export type WhatAppCallToActionInput = {
  /** The whatsapp number */
  number?: InputMaybe<Scalars["String"]["input"]>;
  /** The text of the call to action */
  text?: InputMaybe<Scalars["String"]["input"]>;
  /** The type of the call to action */
  type: CallToActionType;
};

/** Call to action */
export type WhatsAppCallToAction = {
  __typename?: "WhatsAppCallToAction";
  /** The phone number to send the WhatsApp message to */
  phoneNumber?: Maybe<Scalars["String"]["output"]>;
  /** The text of the call to action */
  text?: Maybe<Scalars["String"]["output"]>;
  /** The type of the call to action */
  type: CallToActionType;
};

/** The available work areas */
export enum WorkArea {
  /** Customer service */
  CustomerService = "CUSTOMER_SERVICE",
  /** Delivery */
  Delivery = "DELIVERY",
  /** Office */
  Office = "OFFICE",
  /** Store */
  Store = "STORE",
  /** Warehouse */
  Warehouse = "WAREHOUSE",
}

/** The input for the working hours */
export type WorkingHoursInput = {
  /** The ranged working hours */
  range?: InputMaybe<RangedWorkingHoursInput>;
};

export type Website_VacancyDetailPage_ApplyForVacancyMutationVariables = Exact<{
  input: ApplyForVacancyInput;
  subsidiary?: InputMaybe<SubsidiaryCode>;
  language?: InputMaybe<LanguageCode>;
}>;

export type Website_VacancyDetailPage_ApplyForVacancyMutation = {
  __typename?: "Mutation";
  applyForVacancy?:
    | {
        __typename?: "ApplyForVacancyFailure";
        rejectionReasons?: Array<string> | null;
        success: boolean;
      }
    | { __typename?: "ApplyForVacancySuccess"; success: boolean }
    | null;
};

export const Website_VacancyDetailPage_ApplyForVacancyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {
        kind: "Name",
        value: "Website_VacancyDetailPage_ApplyForVacancy",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ApplyForVacancyInput" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "subsidiary" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "SubsidiaryCode" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "language" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "LanguageCode" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "applyForVacancy" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "subsidiary" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "subsidiary" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "language" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "language" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "ApplyForVacancySuccess" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "success" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "ApplyForVacancyFailure" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rejectionReasons" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "success" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Website_VacancyDetailPage_ApplyForVacancyMutation,
  Website_VacancyDetailPage_ApplyForVacancyMutationVariables
>;
